import { defineMessages } from 'react-intl'


export default defineMessages({
  buttonDelete: {
    id: 'policy-migrator.delete-button',
    defaultMessage: 'Discard',
  },

  errorMessageReplacePolicy: {
    id: 'policy-migrator.error-message-replace-policy',
    defaultMessage: 'You have already created this policy. Click SAVE to replace the existing one or click "Discard" to discard it.',
  },

  errorRequiredWebsite: {
    id: 'policy-migrator.error-required-website',
    defaultMessage: 'Enter Website',
  },

  labelSelectWebsites: {
    id: 'policy-migrator.label-select-websites',
    defaultMessage: 'Website / Mobile App',
  },

  placeholderSelectWebsite: {
    id: 'policy-migrator.placeholder-select-website',
    defaultMessage: 'Choose a website',
  },

  save: {
    id: 'policy-migrator.save',
    defaultMessage: 'Save',
  },

  titlePolicyMigrator: {
    id: 'policy-migrator.title',
    defaultMessage: 'Choose a website for this {documentName}',
  },

  warning: {
    id: 'policy-migrator.warning',
    defaultMessage: 'You published a new {documentName} while you were logged out. Choose a website to save this policy to, or discard the policy.',
  },
})
